import { GetAudienceOptions } from '../constants/audiences';
import { PAYER_CODE_VALIDATION, EMAIL_VALIDATION, UK_POST_CODE_VALIDATION, REQUIRED_VALIDATION, validateWhiteSpace, LOGO_VALIDATION_WITH_TYPE, PHONE_VALIDATION_V2 } from './_predefinedValidations';

export type MerchantFormTypes = {
  logo: File | string;
  merchantName: string;
  payerCode: string;
  audienceName: AudienceName;
  addressLine1: string;
  addressLine2: string;
  city: string;
  postCode: string;
  county: string;
  email: string;
  phone: string;
};

export type MerchantAddFormTypes = {
  logo: File;
  merchantName: string;
  payerCode: string;
  audienceName: AudienceName;
  addressLine1: string;
  addressLine2: string;
  city: string;
  postCode: string;
  county: string;
  email: string;
  phone: string;
};

export type MerchantDefaultTypes = {
  logo?: string;
  merchantName: string;
  payerCode: string;
  audienceName: AudienceName;
  addressLine1: string;
  addressLine2?: string;
  city: string;
  postCode: string;
  county: string;
  email: string;
  phone: string;
};

type MerchantForm = [
  { title: 'Basic information', fields: [FormImageField, FormInputField, FormInputField, FormSelectField]; },
  { title: 'Head office address', fields: [FormInputField, FormInputField, FormInputField, FormInputField, FormInputField]; },
  { title: 'Contact details', fields: [FormInputField, FormInputField]; }
];

export const MERCHANT_FORM: MerchantForm = [
  {
    title: 'Basic information',
    fields: [
      {
        label: 'Logotype',
        name: 'logo',
        inputType: 'logo',
        validation: {
          required: REQUIRED_VALIDATION,
          validate: LOGO_VALIDATION_WITH_TYPE('image/*')
        }
      },
      {
        label: 'Merchant Name',
        name: 'merchantName',
        inputType: 'text',
        validation: {
          required: REQUIRED_VALIDATION,
          validate: { validateWhiteSpace }
        }
      },
      {
        label: 'Payer/Parent Code',
        name: 'payerCode',
        inputType: 'text',
        validation: {
          required: REQUIRED_VALIDATION,
          pattern: PAYER_CODE_VALIDATION,
          validate: { validateWhiteSpace }
        }
      },
      {
        label: 'Audience',
        name: 'audienceName',
        inputType: 'select',
        options: GetAudienceOptions(),
        validation: {
          required: REQUIRED_VALIDATION,
        }
      },
    ]
  },
  {
    title: 'Head office address',
    fields: [
      {
        label: 'Address Line 1',
        name: 'addressLine1',
        inputType: 'text',
        validation: {
          required: REQUIRED_VALIDATION,
          validate: { validateWhiteSpace }
        }
      },
      {
        label: 'Address Line 2',
        name: 'addressLine2',
        inputType: 'text',
        validation: {
        }
      },
      {
        label: 'City',
        name: 'city',
        inputType: 'text',
        validation: {
          required: REQUIRED_VALIDATION,
          validate: { validateWhiteSpace }
        }
      },
      {
        label: 'Post Code',
        name: 'postCode',
        inputType: 'text',
        validation: {
          required: REQUIRED_VALIDATION,
          pattern: UK_POST_CODE_VALIDATION,
        }
      },
      {
        label: 'County',
        name: 'county',
        inputType: 'text',
        validation: {
          required: REQUIRED_VALIDATION,
          validate: { validateWhiteSpace }
        }
      }
    ]
  },
  {
    title: 'Contact details',
    fields: [
      {
        label: 'Email',
        name: 'email',
        inputType: 'text',
        validation: {
          required: REQUIRED_VALIDATION,
          pattern: EMAIL_VALIDATION,
          validate: { validateWhiteSpace }
        }
      },
      {
        label: 'Phone',
        name: 'phone',
        inputType: 'tel',
        helperText: 'Example: 07975777666',
        validation: {
          pattern: PHONE_VALIDATION_V2,
        }
      },
    ]
  }
];
